import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Header, Footer } from "../../../components";
import Sidebar from "../../../components/Common/Sidebar";
import SidebarNew from "../../../components/Common/SidebarNew";

const InnerMainLayoutAts = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  return (
    <div className={`theme-default h-full flex overflow-clip relative`}>
      <div
        className={`${
          isCollapsed ? "w-20" : "w-64"
        } transition-all duration-500 flex-shrink-0`}
      >
        {/* <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} /> */}
        <SidebarNew isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
      </div>

      <div
        className="flex-1  transition-all duration-500 flex flex-col overflow-hidden"
        style={{
          width: isCollapsed ? "calc(100% - 80px)" : "calc(100% - 256px)",
        }}
      >
        <Header />
        <div className="ml-2 pr-2 py-2 flex flex-1 mb-7 flex-col overflow-auto">
          <Outlet />
        </div>
        <div className="absolute left-0 bottom-0 w-full -z-1">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default InnerMainLayoutAts;
